// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how {
    width: 100%;
    display: grid;
    grid-template-columns: 228px 1fr;
    padding-left: 200px;
    padding-right: 200px;
    padding-top: 20px;
    padding-bottom: 20px;
    gap: 10px;
}

.how__blocks{
    background-color: #f7f7f7;
    display: flex;
    align-items: start;
    justify-content: start;
    padding: 30px;
    flex-direction: column;
    gap: 20px;
}

.how__block {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
}
.how__img{
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
}
.how__title{
    width: 100%;
    display: flex;
    /* gap: 5px; */
    align-items: start;
    justify-content: center;
    flex-direction: column;
}
.how__title p span{
    font-weight: bold;
}
.how__title span{
    color: rgb(51,51,51);
    font-size: 16px;
    letter-spacing: 0.01em;
}
.how__block img{
    width: 90%;
}
.how__desc{
    width: 100%;
    display: flex;
    align-items: start;
    justify-content: center;
    flex-direction: column;
}
.how__desc p{
    font-weight: 700;
}
.how__desc span{
    gap: 5px;
    display: flex;
}
@media(max-width:991px) {
    .how {
        padding-left: 50px;
        padding-right: 50px;
    }
}

@media(max-width: 750px) {
    .how {
        padding-left: 15px;
        padding-right: 15px;
    }
    .how__blocks{
        padding: 10px;
    }
}

@media(max-width:550px) {
    .how {
        display: flex;
        flex-direction: column;
        padding-top: 0px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/style/how.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,QAAQ;IACR,aAAa;AACjB;AACA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;IACpB;AACJ","sourcesContent":[".how {\r\n    width: 100%;\r\n    display: grid;\r\n    grid-template-columns: 228px 1fr;\r\n    padding-left: 200px;\r\n    padding-right: 200px;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    gap: 10px;\r\n}\r\n\r\n.how__blocks{\r\n    background-color: #f7f7f7;\r\n    display: flex;\r\n    align-items: start;\r\n    justify-content: start;\r\n    padding: 30px;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n}\r\n\r\n.how__block {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n.how__img{\r\n    width: 100%;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n}\r\n.how__title{\r\n    width: 100%;\r\n    display: flex;\r\n    /* gap: 5px; */\r\n    align-items: start;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n.how__title p span{\r\n    font-weight: bold;\r\n}\r\n.how__title span{\r\n    color: rgb(51,51,51);\r\n    font-size: 16px;\r\n    letter-spacing: 0.01em;\r\n}\r\n.how__block img{\r\n    width: 90%;\r\n}\r\n.how__desc{\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: start;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n.how__desc p{\r\n    font-weight: 700;\r\n}\r\n.how__desc span{\r\n    gap: 5px;\r\n    display: flex;\r\n}\r\n@media(max-width:991px) {\r\n    .how {\r\n        padding-left: 50px;\r\n        padding-right: 50px;\r\n    }\r\n}\r\n\r\n@media(max-width: 750px) {\r\n    .how {\r\n        padding-left: 15px;\r\n        padding-right: 15px;\r\n    }\r\n    .how__blocks{\r\n        padding: 10px;\r\n    }\r\n}\r\n\r\n@media(max-width:550px) {\r\n    .how {\r\n        display: flex;\r\n        flex-direction: column;\r\n        padding-top: 0px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
